export default __webpack_public_path__ + "static/media/cursor.c10b2c27.svg";